import { render } from "./MSeach.vue?vue&type=template&id=1c784615&scoped=true"
import script from "./MSeach.vue?vue&type=script&lang=js"
export * from "./MSeach.vue?vue&type=script&lang=js"

import "./MSeach.vue?vue&type=style&index=0&id=1c784615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c784615"]])

export default __exports__